import { defineMessages } from 'react-intl';

export const cardMessages = defineMessages({
  averageCost: {
    id: 'HowToPlay.YourBudget.averageCost',
    defaultMessage: 'Average Lineup Cost: {b}',
  },
  averagePoolPrize: {
    id: 'HowToPlay.YourBudget.averagePoolPrize',
    defaultMessage: 'Average Pool Prize: {b}',
  },
  numberOfCompetitions: {
    id: 'HowToPlay.YourBudget.numberOfCompetitors',
    defaultMessage: 'Number of Competitors: {b}',
  },
});

export const cardValues = {
  limited: {
    name: 'Limited',
    averageCost: '€100.00',
    averagePoolPrize: '€100.00',
    numberOfCompetitors: '+25 000',
  },
  rare: {
    name: 'Rare',
    averageCost: '€350.00',
    averagePoolPrize: '€100.00',
    numberOfCompetitors: '+2 000',
  },
  super_rare: {
    name: 'Super Rare',
    averageCost: '€3,000.00',
    averagePoolPrize: '€20,000.00',
    numberOfCompetitors: '+2 000',
  },
  unique: {
    name: 'Unique',
    averageCost: '€20,000.00',
    averagePoolPrize: '€20,000.00',
    numberOfCompetitors: '+500',
  },
  common: {
    name: 'Common',
    averageCost: 'Free',
    averagePoolPrize: '€0.00',
    numberOfCompetitors: '+100 000',
  },
} as const;
